import React, {Component} from 'react';

class ReportsAction extends Component {
    render() {
        return (
            <React.Fragment>
                {
                    !this.props.loading ? (
                        <button className="btn btn-primary" onClick={this.props.generate}>Request Generate Report</button>
                    ) : (
                        <button className="btn btn-primary" disabled>
                            <i className="fa fa-spinner fa-spin"></i>
                            Requesting....
                        </button>
                    )
                }
                <button className="btn btn-primary pull-right" onClick={this.props.addPeriod} disabled={this.props.disabled}>Add Period</button>
            </React.Fragment>
        );
    }
}

export default ReportsAction;